module.exports = __webpack_public_path__ + "img/fundect_logo.586613d2.webp";